import { configureStore } from '@reduxjs/toolkit';

import notifyReducer from './notifySlice';
import settingsReducer from './settingsSlice';
import sectionsReducer from './sectionsSlice';
import categoriesReducer from './categoriesSlice';
import optionsReducer from './optionsSlice';
import variantsReducer from './variantsSlice';
import productsReducer from './productsSlice';
import promosReducer from './promosSlice';
import cartReducer from './cartSlice';
import workingTimeReducer from './workingTimeSlice';

export default configureStore({
  reducer: {
    notify: notifyReducer,
    workingTime: workingTimeReducer,
    settings: settingsReducer,
    sections: sectionsReducer,
    categories: categoriesReducer,
    products: productsReducer,
    variants: variantsReducer,
    options: optionsReducer,
    promos: promosReducer,
    cart: cartReducer,
  }
});
